import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const ASPECT_RATIO = 250 / 312;
const WIDTH = 300;
const BACKGROUND_COLOR = "#F0F0F0";
const BASE_Z_INDEX = 200;
const style = ({ index }) => {
    const { borderRadius3, elevationLayerM, shadowColor, shadowOffset, shadowOpacityS, shadowOpacityM, shadowRadius } = theme();
    return StyleSheet.create({
        activeShadow: {
            elevation: elevationLayerM,
            shadowColor: shadowColor,
            shadowOffset: shadowOffset,
            shadowOpacity: shadowOpacityM,
            shadowRadius: shadowRadius,
        },
        baseShadow: {
            elevation: 1,
            shadowColor: shadowColor,
            shadowOffset: shadowOffset,
            shadowOpacity: shadowOpacityS,
            shadowRadius: shadowRadius,
        },
        card: {
            aspectRatio: ASPECT_RATIO,
            backgroundColor: BACKGROUND_COLOR,
            borderRadius: borderRadius3,
            position: "absolute",
            width: WIDTH,
            zIndex: BASE_Z_INDEX - index,
        },
        image: {
            height: "100%",
            width: "100%",
        },
    });
};
export { style, WIDTH, ASPECT_RATIO };
